module.exports = __webpack_public_path__ + "img/hr-H-T-123456-unload-standup-base.3df35d5e.png";